import { component$, Slot } from "@builder.io/qwik";

interface ContainerProps {
  pagePadding?: boolean;
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "full";
}

export const Container = component$((props: ContainerProps) => {
  const maxWidthClasses = {
    sm: "max-w-screen-sm",
    md: "max-w-screen-md",
    lg: "max-w-screen-lg",
    xl: "max-w-screen-xl",
    "2xl": "max-w-screen-2xl",
    prose: "max-w-prose",
    full: "max-w-full",
  };

  return (
    <div
      class={[
        `mx-auto flex w-full flex-col items-stretch gap-4 px-4 md:gap-8`,
        props.maxWidth && maxWidthClasses[props.maxWidth],
        {
          "py-8 md:py-16": props.pagePadding,
        },
      ]}
    >
      <Slot />
    </div>
  );
});
